export default __webpack_public_path__ + "static/media/protip_topup.d80ece7a.png";